import { connectStateResults, Highlight, Hits, InstantSearch, Pagination, PoweredBy, SearchBox } from 'react-instantsearch-dom';
import React, { useState } from 'react';
import algoliasearch from 'algoliasearch/lite';
import StateResults from './StateResults';

const algoliaClientForBzh = algoliasearch('9GP8NTGDLX', '57f19e2992e4fc53eac362186c7996a7');

const CustomStateResults = connectStateResults(StateResults);

// fix initial query with empty parameters
// https://www.algolia.com/doc/guides/building-search-ui/going-further/conditional-requests/react/
// https://codesandbox.io/s/github/algolia/doc-code-samples/tree/master/React%20InstantSearch/conditional-request?file=/src/App.js:255-292
const searchClientForBzh = {
  search (requests) {
    if (requests.every(({ params }) => !params.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          processingTimeMS: 0,
        })),
      });
    }

    return algoliaClientForBzh.search(requests);
  },
};

function DicosForBzh () {
  const [ wordToLookFor, setWordToLookFor ] = useState('');

  return (<>
    <form noValidate onSubmit={e => { e.preventDefault(); }}>
      <div>
        <label htmlFor="theWordToLookFor">Word to open in a dictionary</label>
        <button className="copy-search-word" onClick={() => setWordToLookFor(document.querySelector('.app-bzh input[type="search"]').value)}>copy from search input</button>
      </div>
      <input type="text"
             id="theWordToLookFor"
             name="theWordToLookFor"
             value={wordToLookFor}
             className="dico__component dico__input"
             onChange={(e) => setWordToLookFor(e.target.value)} required />
      <div className="dico_hrefs">
        <a href={'https://fr.glosbe.com/br/fr/' + wordToLookFor} target="_blank" rel="noopener noreferrer"
           className="dico__href">Dico BZH-FR</a>
        <a href={'https://fr.glosbe.com/fr/br/' + wordToLookFor} target="_blank" rel="noopener noreferrer"
           className="dico__href">Dico FR-BZH</a>
      </div>
    </form>
    <div className="other-links">
      <a href={'https://pgu-bzh.netlify.app/'} target="_blank" rel="noopener noreferrer"
         className="other-links_mutations">Mutations? check it out</a>
    </div>
  </>);

}

function HitForBzh (props) {

  const [ isAdditionalWordsExpanded, setAdditionalWordsExpanded ] = useState(false);
  const [ isArticleCollapsed, setArticleCollapsed ] = useState(false);

  return (
    <article className={`${isArticleCollapsed ? 'article__display-mode--collapsed' : ''}`}>
      {((props.hit.text_bzh.match(/\n/g) || []).length > 3) && <button onClick={() => {setArticleCollapsed(!isArticleCollapsed);}}
                                                                       className="article__display-mode">
        {isArticleCollapsed ? '+' : '-'}
      </button>
      }
      <p className="hit__text hit__text--bzh">
        <Highlight attribute="text_bzh" hit={props.hit} />
      </p>
      <p className="hit__text hit__text--fr">
        <Highlight attribute="text_fr" hit={props.hit} />
      </p>
      {(props.hit.additional_keywords_bzh || props.hit.additional_keywords_fr) && <aside>
        <button onClick={() => {setAdditionalWordsExpanded(!isAdditionalWordsExpanded);}}
                className={`hit__additional-keywords__btn ${isAdditionalWordsExpanded ? 'hit__additional-keywords__btn--expanded' : ''}`}>{'>'}</button>
        <div className={`hit__additional-keywords ${isAdditionalWordsExpanded ? 'hit__additional-keywords--expanded' : 'hit__additional-keywords--reduced'}`}>
          <p className="hit__additional-keywords--bzh">
            <Highlight attribute="additional_keywords_bzh" hit={props.hit} />
          </p>
          <p className="hit__additional-keywords--fr">
            <Highlight attribute="additional_keywords_fr" hit={props.hit} />
          </p>
        </div>
      </aside>
      }
    </article>
  );
}


export default function AppBzh () {
  return (
    <main className="app-bzh">
      <h2 className={'visually-hidden'}>App Bzh</h2>
      <section className="ais-InstantSearch">
        <InstantSearch indexName="dev_bzh" searchClient={searchClientForBzh}>
          <SearchBox showLoadingIndicator autoFocus searchAsYouType={false} />
          <CustomStateResults />
          <Hits hitComponent={HitForBzh} />
          <Pagination />
          <PoweredBy />
        </InstantSearch>
      </section>
      <section className="dico__section">
        <DicosForBzh />
      </section>
    </main>
  );
}
